import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Stack } from "@mui/material";
import { ContentCard } from "@shared";
import { FormikProps } from "formik";

import { CounselorWorkTimeFormValues } from "@/pages/system-settings/tabs/counselors/pages/counselor-detail/pages/work-time/CounselorWorkTime.types";
import { useTranslation } from "@/translations";

import { WorkTimeAllocationRow } from "../work-time-allocation-row/WorkTimeAllocationRow";

interface Props {
  formik: FormikProps<CounselorWorkTimeFormValues>;
  workAreaOptions: string[];
  teamOptions: string[];
  onAdd: () => void;
  onDelete: (index: number) => void;
}

export function WorkTimeAllocationCard({ formik, workAreaOptions, teamOptions, onAdd, onDelete }: Props) {
  const { t } = useTranslation();

  return (
    <ContentCard title={t("counselors.workTime.allocation.title")}>
      <Stack gap={2}>
        {formik.values.allocations.map((allocation, index) => (
          <WorkTimeAllocationRow
            key={allocation.id ?? `new-${index}`}
            formik={formik}
            index={index}
            workAreaOptions={workAreaOptions}
            teamOptions={teamOptions}
            onDelete={() => onDelete(index)}
          />
        ))}

        <Box>
          <Button variant="text" size="small" startIcon={<AddIcon />} onClick={onAdd}>
            {t("counselors.workTime.allocation.addButton")}
          </Button>
        </Box>
      </Stack>
    </ContentCard>
  );
}
